/**
 * Created by Alican Köker on 2018-09-21.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {FruitsReelController} from "./FruitsReelController";

export class FruitsReelPartAnimator extends SpinReelPartAnimator {

    private _scatterLevelSymbol:string = "S";
    private _replaceX:boolean = false;

    public static readonly REPLACE_X:string = "fruitsReelPartAnimator_setGameMode";

    constructor(reelId:number) {
        super(reelId);

        EventHandler.addEventListener(this, FruitsReelController.UPDATE_SCATTER_LEVEL, (event:GameEvent) => this.updateScatterLevel(event.params[0]));
        EventHandler.addEventListener(this, FruitsReelPartAnimator.REPLACE_X, (event:GameEvent) => {
            this._replaceX = event.params[0];
            /*if(this._replaceX && this._symbolsToAnimate && this._symbolsToAnimate[0] && this._symbolsToAnimate[0].symName === "X")
                this._symbolsToAnimate[0].replaceWith(FruitsHelper.randomizeSymbol());*/
        });
    }

    /*protected queueSymbolToReelAnimation(reelSymbol:StateReelSymbol):void {
        if(reelSymbol && reelSymbol.symName.substr(0, 1) === "S" && this._scatterLevelSymbol !== reelSymbol.symName)
            reelSymbol.replaceWith(this._scatterLevelSymbol);

        this._symbolToBeAdded = reelSymbol;
    }*/

    private updateScatterLevel(level:number):void {
        switch(level) {
            case 1:
                this._scatterLevelSymbol = "S";
                break;
            case 2:
                this._scatterLevelSymbol = "S_B";
                break;
            case 3:
                this._scatterLevelSymbol = "S_C";
                break;
            case 4:
                this._scatterLevelSymbol = "S_D";
                break;
            default:
                break;
        }

    }

}